import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import appActions from "../slices/appActions";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Persist configuration for auth
const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["isLoggedIn", "user"],
};

const appPersistConfig = {
  key: "appActions",
  storage,
  whitelist: ["sendingType"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  appActions: persistReducer(appPersistConfig, appActions),
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
